import CommonDialog from "../../common/CommonDialog/CommonDialog";
import React, { useEffect, useState } from "react";
import {
  CapturePhotoButton,
  PhotoCaptureWindow,
  TakePhotoWrapper,
} from "./UserProfileModal.style";
import { useSnackbar } from "notistack";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { useTranslation } from "hhn-commons";

interface TakePhotoModalProps {
  open: boolean;
  closeModal: () => void;
}

export const TakePhotoModal = ({ open, closeModal }: TakePhotoModalProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [isCapturingPhoto, setIsCapturingPhoto] = useState<boolean>(false);

  //TODO: Uncomment this while implementing the feature
  // const closePhotoCaptureWindow = () => {
  //   setIsCapturingPhoto(false);
  // };

  const openPhotoCaptureWindow = () => {
    setIsCapturingPhoto(true);
  };

  useEffect(() => {
    open && openPhotoCaptureWindow();
  }, [open]);

  const capturePhoto = () => {
    enqueueSnackbar(t("notImplemented"), {
      autoHideDuration: 3000,
    });
  };

  return (
    <>
      <CommonDialog
        isDialogOpen={open}
        onDialogClose={closeModal}
        title={""}
        titleAlignment="center"
        maxWidth="sm"
      >
        {!isCapturingPhoto && <TakePhotoWrapper></TakePhotoWrapper>}
        {isCapturingPhoto && (
          <PhotoCaptureWindow>
            <CapturePhotoButton onClick={capturePhoto}>
              <CameraAltIcon />
            </CapturePhotoButton>
          </PhotoCaptureWindow>
        )}
      </CommonDialog>
    </>
  );
};
